import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { SelectOption } from '../../atoms';
import { TRY_THEN_BUY_FRAUD } from '../../../constants/define/translation';
import { TTB_FRAUD_FILTER_STATUS } from '../../../constants/ttb-fraud';
import { FilterTTBFraudType } from '../../../types/tryThenBuyFraud';
import { appStyles } from '../../../styles';

interface TTBFraudFilterProps {
  getFilteredData: (data: any) => void;
  options: FilterTTBFraudType;
}

export const TTBFraudFilter = (props: TTBFraudFilterProps) => {
  const { t } = useTranslation(TRY_THEN_BUY_FRAUD);
  const { getFilteredData, options } = props;

  const onHandleSelectTTBFraudStatus = useCallback(
    values => {
      getFilteredData({
        status: values,
      });
    },
    [getFilteredData],
  );

  return (
    <StyledRowFilter>
      <Col span={16} className="full-width">
        <div className="text-filter">
          <span className="text">{t('filter.status')}: </span>
        </div>

        <SelectOption
          multiple
          values={TTB_FRAUD_FILTER_STATUS}
          showSearch
          defaultValue={options?.status}
          placeholder={t('filter.status')}
          onChange={onHandleSelectTTBFraudStatus}
          textDisplay="text"
        />
      </Col>
      <Col span={8}>
        <StyledSearchInput
          onChange={e => {
            getFilteredData({
              strSearch: e.target.value,
            });
          }}
          value={options?.strSearch}
          placeholder={t('filter.searchPlaceholder')}
          suffix={
            !options?.strSearch ? (
              <SearchOutlined />
            ) : (
              <CloseOutlined
                onClick={() => {
                  getFilteredData({
                    strSearch: '',
                  });
                }}
              />
            )
          }
        />
      </Col>
    </StyledRowFilter>
  );
};

const StyledRowFilter = styled(Row)`
  padding: 0.5rem 0 0.75rem;
  & .full-width {
    .ant-select {
      width: 280px;
      min-width: 280px;
      max-width: 400px;
    }
  }

  & .ant-col {
    display: flex;
    & .text-filter {
      display: table;
      height: 36px;
      margin-right: 0.5rem;
      & span {
        font-weight: bold;
        font-size: 14px;
        display: table-cell;
        vertical-align: middle;
      }
    }
    & .ant-select-selector {
      line-height: 1.89;
    }
  }

  & .div-filter-passScheduledArrivalDate,
  & .div-filter-abnormalOrder {
    padding: 0.22rem;
  }
`;

const StyledSearchInput = styled(Input)`
  ${appStyles.searchInput}
`;
